module.exports = __webpack_public_path__ + "img/energy_fac_grey.4a40f365.png";